import {
  BrandCreateBody,
  BrandDetailResponse,
  BrandItem,
  BrandListResponse,
} from "../types"

export class BrandStore {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<BrandListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/brand-store`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  create(
    vendorId: string,
    body: BrandCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<BrandItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/brand-store`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: BrandCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<BrandItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/brand-store/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<BrandDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/brand-store/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/brand-store/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
